import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { menuItems } from "../data/menuItems";
import logo from "../assets/img/logo.png";

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeSubmenus, setActiveSubmenus] = useState({});

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    document.body.classList.toggle('no-scroll', !mobileMenuOpen);
  };

  const toggleSubmenu = (idx) => {
    setActiveSubmenus((prev) => ({
      ...prev,
      [idx]: !prev[idx]
    }));
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 992) {
        setMobileMenuOpen(false);
        document.body.classList.remove('no-scroll');
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <header id="header">
      <div id="header-wrapper">
        <div className="nav-center">
          <div className="nav-left">
            <div className="nav-brand">
              <Link to="/" title="Inicio">
                <img id="logo" src={logo} alt="Logo" />
                <p className="h1">EL RETO IMPOSIBLE</p>
              </Link>
            </div>
          </div>

          <div className="nav-right">
            <div className="nav-toggle">
              <div className="btn--toggle" onClick={toggleMobileMenu}>
                <div id="mobile-header-menu-toggle" className={mobileMenuOpen ? 'open' : ''}>
                  <i className="icon-bar"></i>
                  <i className="icon-bar"></i>
                  <i className="icon-bar"></i>
                </div>
              </div>
            </div>

            <div className={`nav-collapse ${mobileMenuOpen ? 'mobile' : ''}`}>
              <nav>
                <ul id="collapse" 
                    className={`nav-list ${mobileMenuOpen ? 'showing' : ''}`}
                    style={mobileMenuOpen ? { overflowY: 'auto' } : {}}>
                  {menuItems.map((item, idx) => (
                    <li key={idx} className={`nav-list__item lv1 ${item.subItems ? 'submenu--trigger' : ''} ${activeSubmenus[idx] ? 'active' : ''}`}>
                      {item.subItems ? (
                        <>
                          <span className="nav-link nopointer" onClick={() => toggleSubmenu(idx)}>
                            {item.title}
                            <i className="caret-down-icon i-submenu"></i>
                          </span>
                          <ul className="submenu">
                            {item.subItems.map((sub, subIdx) => (
                              <li key={subIdx} className="nav-list__item lv2">
                                <Link className="nav-link" to={sub.path}>{sub.label}</Link>
                              </li>
                            ))}
                          </ul>
                        </>
                      ) : (
                        <Link className="nav-link" to={item.path}>{item.title}</Link>
                      )}
                    </li>
                  ))}
                </ul>
              </nav>
            </div>

          </div>
        </div>
      </div>
    </header>
  );
}
